import { render } from "./Myprofile.vue?vue&type=template&id=61f3d701&scoped=true"
import script from "./Myprofile.vue?vue&type=script&lang=js"
export * from "./Myprofile.vue?vue&type=script&lang=js"

import "./Myprofile.vue?vue&type=style&index=0&id=61f3d701&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-61f3d701"

export default script